import React from 'react';

const Title = ({ title }) => {
  return (
    <div className="card-header text-green-1 text-center">
      <h3>{title}</h3>
    </div>
  );
};

export default Title;
